import { z } from 'zod';
import { ECallFlowType, EQueueDispatchMode } from '../enums/call-flow.enum';
import { callFlowSettingsSchema } from './voice-messages.schema';

export const updateCallConfigSchema = z.object({
    flowType: z.nativeEnum(ECallFlowType).optional(),
    queueDispatchMode: z.nativeEnum(EQueueDispatchMode).optional(),
    isEnabled: z.boolean().optional(),
    settings: callFlowSettingsSchema.nullable().optional(),
});

export type UpdateCallConfigInput = z.infer<typeof updateCallConfigSchema>;